var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelectYourLoaction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 101,
    viewBox: "0 0 68 101",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34 0c18.778 0 34 15.222 34 34a33.842 33.842 0 0 1-4.841 17.496L34.5 100.997 5.071 51.873A33.841 33.841 0 0 1 0 34C0 15.222 15.222 0 34 0zm0 14c-11.046 0-20 8.954-20 20s8.954 20 20 20 20-8.954 20-20-8.954-20-20-20z",
    fill: "#D4382A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.511.004 34 0c18.778 0 34 15.222 34 34a33.842 33.842 0 0 1-4.841 17.496L34.51 100.978V53.994C45.322 53.722 54 44.874 54 34c0-10.875-8.68-19.722-19.488-19.994L34.51.004z",
    fill: "#B4321E"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectYourLoaction);
export default __webpack_public_path__ + "static/media/select-your-loaction.6a4e1c849bd31663f0d3a2e4fe8098f4.svg";
export { ForwardRef as ReactComponent };